import type { ConnectedControllers } from '../input/connectedControllers/connectedControllers.types'
import type { Mode } from '../mode/mode/mode.types'
import { makeControllerMates } from './controllerMates/controllerMates'
import { makeOmniMates } from './omniMates/omniMates'
import { makeLocalMatesCore } from './localMates/localMates'
import { makeDeviceProfiles } from './deviceProfiles/deviceProfiles'
import type { LocalMatesSystem } from './localMates.types'

export interface MakeLocalMatesDeps {
  mode: Mode
  connectedControllers: ConnectedControllers
}

/**
 * Create the local mates system.
 *
 * This system manages all mates that originate from this client:
 * - Controller-based mates (shared-screen mode)
 * - Omni mates (Omni mode)
 * - Single mate (regular mode)
 * - Active local Omni mate tracking (Omni mode only)
 */
export function makeLocalMates(deps: MakeLocalMatesDeps): LocalMatesSystem {
  const { mode, connectedControllers } = deps

  const deviceProfiles = makeDeviceProfiles()
  const controllerMates = makeControllerMates({ connectedControllers, mode, deviceProfiles })
  const omniMates = makeOmniMates({})
  const localMates = makeLocalMatesCore({ mode, controllerMates, omniMates })

  return {
    controllerMates,
    omniMates,
    localMates,
    deviceProfiles,
  }
}
